import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {BaseurlService} from '../../services/baseurl.service';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChromeKrakenService {

  constructor(
    private http: HttpClient,
    private baseUrl: BaseurlService,
  ) { }

  getTabs(): Observable<ChromeKrakenTabEntity[]> {
    return this.http.get<ChromeKrakenTabEntity[]>(`${this.baseUrl.getBaseUrl()}/chromeKraken/tabs`);
  }

  searchTabs(request: ChromeKrakenSearchRequest): Observable<Page<ChromeKrakenTabEntity>> {
    let params = new HttpParams();
    Object.entries(request).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        params = params.set(key, value as string | number | boolean);
      }
    });
    return this.http.get<Page<ChromeKrakenTabEntity>>(`${this.baseUrl.getBaseUrl()}/chromeKraken/tabs/search`, {params});
  }

  getDevices(): Observable<string[]> {
    return this.http.get<string[]>(`${this.baseUrl.getBaseUrl()}/chromeKraken/devices`);
  }

}

export interface ChromeKrakenSearchRequest {
  q?: string | null;
  createdFrom?: string | null;
  createdTo?: string | null;
  updatedFrom?: string | null;
  updatedTo?: string | null;
  closedFrom?: string | null;
  closedTo?: string | null;
  device?: string | null;
  includeIncognito?: boolean | null;
  page: number;
  size: number;
}

export interface Page<T> {
  content: T[];
  totalPages: number;
  totalElements: number;
  last: boolean;
  size: number;
  number: number;
  sort: { property: string; direction: 'ASC' | 'DESC'}[];
  first: boolean;
  numberOfElements: number;
}


export interface ChromeKrakenTabEntity {
  id: number;
  installation: ChromeKrakenNameEntity;
  tabId: number;
  created: string;
  lastUpdated: string;
  closed?: string;
  url: string;
  raw: Tab;
}

export interface ChromeKrakenNameEntity {
  id?: number;
  installUid: string;
  clientName: string;
}

export interface Tab {
  active: boolean;
  audible: boolean;
  autoDiscardable: boolean;
  discarded: boolean;
  favIconUrl?: string;
  groupId?: number;
  height?: number;
  highlighted?: boolean;
  id: number;
  incognito: boolean;
  index: number;
  mutedInfo?: MutedInfo;
  pinned?: boolean;
  selected?: boolean;
  status?: string;
  title?: string;
  url?: string;
  width?: number;
  windowId: number;
  openerTabId?: number;
}

export interface MutedInfo {
  muted?: boolean;
}
